<div class="modal-container d-flex justify-content-center align-items-center" mat-dialog-content>
  <div class="modal-content text-center" style="padding: 16px 32px;">
    <span class="texto-2 text-black text-center mb-4">Sua solicitação de parceria expirou</span>
    <p class="texto-2 texto-2--color-segundario text-center fw-400 mb-4">
      Você pode continuar o processo da onde parou até a data {{ dataVencimento ? moment(dataVencimento).format('DD/MM/YYYY') : '-' }}.
      Após isso, sua solicitação será excluída definitivamente. Para reativar o seu cadastro, entre em contato conosco.
    </p>
    <div class="mb-3">
      <button class="btn btn-primary" type="button" (click)="authService.logout()">
        Sair do sistema
        <img src="assets/imgs/icones/sair-white.svg" class="ms-2" alt="">
      </button>
    </div>
  </div>
</div>


